import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
//
import enLocales from './en/translations.json';
import enNavbarLocales from './en/navbar.json';
import enToolkitLocales from './en/toolkit.json';

import frLocales from './fr/translations.json';
import frNavbarLocales from './fr/navbar.json';

// ----------------------------------------------------------------------

let lng = 'en';

if (typeof localStorage !== 'undefined') {
  lng = localStorage.getItem('i18nextLng') || 'en';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: enLocales,
        navbar: enNavbarLocales,
        toolkit: enToolkitLocales
      },
      fr: {
        translations: frLocales,
        navbar: frNavbarLocales,
        toolkit: enToolkitLocales
      }
    },
    lng,
    fallbackLng: 'en',
    debug: false,
    ns: ['translations', 'navbar', 'toolkit'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
